import { render, staticRenderFns } from "./CosmoformTemplate.vue?vue&type=template&id=f94ff9ce&scoped=true"
import script from "./CosmoformTemplate.vue?vue&type=script&lang=js"
export * from "./CosmoformTemplate.vue?vue&type=script&lang=js"
import style0 from "./CosmoformTemplate.vue?vue&type=style&index=0&id=f94ff9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94ff9ce",
  null
  
)

export default component.exports